import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { array, boolean, nullable, string } from "../../../types/_types";

import { UserRef } from "../../users/types/User";

import { CommentRef } from "./Comment";

export const DiscussionChannel = FirestoreDocument.extend({
	name: string(),
	userIds: array(string()),
	users: array(UserRef),
	teamRoles: nullable(array(string())),
	producerId: string(),
	subject: nullable(
		FirestoreDocument.extend({
			name: string(),
			language: string(),
		}),
	),
	seenByUserIds: array(string()),
	lastComment: nullable(CommentRef),
	channels: array(string()),
	needsAttention: nullable(boolean()),
}).merge(FirestoreLifecycle);
